export default "/images/minus.svg?3960a952397fc6097f89e811764004f8";